import { createMemo } from 'react-use'
import { mapValueKey } from '@editorUtils'
import { useSystemManagerStore } from '@editorStores'

const elementIdToAssembly = (
  assemblies: Assembly[],
  assemblyAssignment: AssemblyAssignment[],
): Record<string, Assembly | undefined> => {
  const assemblyIdToAssembly = mapValueKey(assemblies)
  return assemblyAssignment.reduce((collector, assignment) => {
    const assembly = assemblyIdToAssembly[assignment.assembly_guid]
    if (assembly) {
      collector[assignment.element_guid] = assembly
    }
    return collector
  }, {} as Record<string, Assembly | undefined>)
}

const useMapElementIdToAssembly = createMemo(elementIdToAssembly)

/**
 * Hook that provides a mapping from wall GUID to assembly name
 * @returns Record<string, string | undefined> - Map of wall GUID to assembly name (undefined if no assembly assigned)
 */
const useElementIdToAssembly = (): Record<string, Assembly | undefined> => {
  const assemblies = useSystemManagerStore(state => state.assemblies)
  const assemblyAssignment = useSystemManagerStore(state => state.assemblyAssignment)

  return useMapElementIdToAssembly(assemblies, assemblyAssignment)
}

export default useElementIdToAssembly
